import type { WorkflowRunPayload } from '@Application/WorkflowRuns/WorkflowRun/Actions/workflowRunFetched';

/** `201`: the whole run, refreshed (`canGenerate`, `blockedReason` and `missingAutomaticSources` may all have moved). */
export type WorkflowRunSourceAddedAction = {
	type: 'WORKFLOW_RUN_SOURCE_ADDED';
	payload: WorkflowRunPayload;
	facilityId: number;
	typeKey: string;
	subjectId: number;
};

export default (
	payload: WorkflowRunPayload,
	facilityId: number,
	typeKey: string,
	subjectId: number,
): WorkflowRunSourceAddedAction => ({
	type: 'WORKFLOW_RUN_SOURCE_ADDED',
	payload,
	facilityId,
	typeKey,
	subjectId,
});
